export const isPciProxyInitialized = () => Boolean(window.Inline);
